import { NewButton, NewButtonVariant } from "@visiblethread/react-components";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const FileImport = ({
  accepts,
  handleFileChange,
  selectedFile,
  labelText,
  error = "",
  bodyText,
}) => {
  const handleUploadFile = () => {
    document.getElementById("import-file").click();
  };
  return (
    <div className="import__file" data-testid="file-import">
      <label htmlFor="import-file">
        <span>{labelText || "File to Import"}</span>
        <div>
          <input
            type="text"
            placeholder="Select File To Import"
            value={selectedFile ? selectedFile.name : ""}
            className={clsx(error !== "" && "input__error")}
            disabled
          />

          <NewButton
            onClick={() => {
              handleUploadFile();
            }}
            variant={NewButtonVariant.l1}
            data-testid="import-file-button"
          >
            Browse
          </NewButton>
        </div>
        <span className={`input__error__message ${error !== "" && "show"}`}>
          {error}
        </span>
        <input
          type="file"
          className="import__file__input"
          id="import-file"
          accept={accepts}
          onChange={handleFileChange}
          data-testid="import-file-input"
        />
      </label>
      <div className="import__file__body_text">{bodyText || ""}</div>
    </div>
  );
};

export default FileImport;

FileImport.propTypes = {
  accepts: PropTypes.string,
  handleFileChange: PropTypes.func.isRequired,
  selectedFile: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelText: PropTypes.string,
  error: PropTypes.string,
  bodyText: PropTypes.string,
};
